import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = { class: "bg-gray-800 py-8 px-6 shadow-md sm:rounded-lg sm:px-10 border border-gray-700" }
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = {
  key: 2,
  class: "text-center"
}
const _hoisted_7 = { class: "text-gray-400 mb-6" }
const _hoisted_8 = {
  key: 0,
  class: "bg-red-900 border border-red-700 text-red-300 px-3 py-2 rounded relative text-sm mb-4",
  role: "alert"
}
const _hoisted_9 = { class: "block sm:inline" }
const _hoisted_10 = { class: "space-y-3" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormButton = _resolveComponent("FormButton")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isVerifying)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4" }, null, -1),
              _createElementVNode("h2", { class: "text-2xl font-extrabold text-white mb-2" }, " Verifikacija email-a ", -1),
              _createElementVNode("p", { class: "text-gray-400" }, " Molimo sačekajte dok verifikujemo vaš email... ", -1)
            ])))
          : (_ctx.verificationStatus === 'success')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-green-400 text-6xl mb-4" }, "✓", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-2xl font-extrabold text-white mb-2" }, " Email uspešno verifikovan! ", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-gray-400 mb-6" }, " Vaš email je uspešno potvrđen. Sada možete da se prijavite na vaš nalog. ", -1)),
                _createVNode(_component_FormButton, {
                  onClick: _ctx.goToLogin,
                  class: "w-full"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Idite na prijavu ")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_ctx.verificationStatus === 'error')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-red-400 text-6xl mb-4" }, "✗", -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-2xl font-extrabold text-white mb-2" }, " Greška pri verifikaciji ", -1)),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1),
                  (_ctx.serverError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.serverError), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.showResendOption)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_FormInput, {
                            id: "resend-email",
                            name: "email",
                            type: "email",
                            label: "Email adresa",
                            modelValue: _ctx.resendEmail,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.resendEmail) = $event)),
                            placeholder: "Unesite vašu email adresu",
                            error: _ctx.emailError
                          }, null, 8, ["modelValue", "error"]),
                          _createVNode(_component_FormButton, {
                            onClick: _ctx.handleResendVerification,
                            loading: _ctx.isResending,
                            class: "w-full mt-3"
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode(" Pošaljite ponovo ")
                            ])),
                            _: 1
                          }, 8, ["onClick", "loading"])
                        ]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showResendOption = true)),
                          class: "w-full bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
                        }, " Pošaljite verifikaciju ponovo ")),
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "block text-center text-indigo-400 hover:text-indigo-300"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" Nazad na prijavu ")
                      ])),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}